import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NavigationState {
  hasNavigatedBack: boolean;
}

const initialState: NavigationState = {
  hasNavigatedBack: false,
};

export const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setHasNavigatedBack(state, action: PayloadAction<boolean>) {
      state.hasNavigatedBack = action.payload;
    },
  },
});

export const { setHasNavigatedBack } = navigationSlice.actions;
